/**
 * Badge component.
 */

import clsx from 'clsx'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger'
  size?: 'sm' | 'md'
  className?: string
}

const variantStyles = {
  default: 'bg-tg-secondary-bg text-tg-hint',
  primary: 'bg-tg-button text-tg-button-text',
  success: 'bg-green-500 text-white',
  warning: 'bg-yellow-500 text-white',
  danger: 'bg-red-500 text-white',
}

const sizeStyles = {
  sm: 'text-[10px] px-1.5 py-0.5 min-w-[16px]',
  md: 'text-xs px-2 py-0.5 min-w-[20px]',
}

export function Badge({
  children,
  variant = 'default',
  size = 'sm',
  className,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center font-medium rounded-full',
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
    >
      {children}
    </span>
  )
}
